var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("list"),(_vm.productos_admin)?_c('v-pagination',{attrs:{"length":_vm.pages,"value":_vm.paginacion_productos_admin.page,"circle":""},on:{"input":_vm.paginationChangeHandler}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }